import { ODataCollectionResponseV4 } from "@odata2ts/odata-core";
import { useQueryClient } from "@tanstack/react-query";
import { APPMain_GF_ProductsWaitingForValidation } from "../odata/appu4dm/AppU4DMModel";
import { qAPPMain_GF_ProductsWaitingForValidation } from "../odata/appu4dm/QAppU4DM";
import { useMachine } from "../queries/machine/use-machine";
import { useSignal } from "./use-signal";
import { taskKeys } from "../queries/tasks/task-keys";
import { signal } from "./message";

const productsWaitingForValidationFilter = (machineId?: string | null) =>
  qAPPMain_GF_ProductsWaitingForValidation.WorkcenterNId.eq(
    machineId ?? null
  ).toString();

type ProductsWaitingForValidationSignal = {
  Action: "Added" | "Modified";
} & APPMain_GF_ProductsWaitingForValidation;

function productsWaitingForValidationSignal(machineId?: string | null) {
  return signal<{ d: [ProductsWaitingForValidationSignal] }>({
    enabled: !!machineId,
    app: "AppU4DM",
    channel: "APPMain_GF_ProductsWaitingForValidation",
    filters: productsWaitingForValidationFilter(machineId),
  });
}

export function useProductsWaitingForValidationSignal() {
  const { machine } = useMachine();
  const queryClient = useQueryClient();

  return useSignal(
    productsWaitingForValidationSignal(machine?.EquipmentNId),
    ({ d: [{ Action, ...product }] }) => {
      if (Action === "Modified" || Action === "Added") {
        const key = taskKeys.getProductsWaitingForValidation(
          machine?.EquipmentNId,
          product.ProductId
        );

        queryClient.setQueryData<
          | ODataCollectionResponseV4<APPMain_GF_ProductsWaitingForValidation>
          | undefined
        >(key, (oldData) => ({
          ...oldData,
          value: [
            product,
            ...(oldData?.value.filter(
              (x) => x.ProductId !== product.ProductId
            ) ?? []),
          ],
        }));

        // do we want to invalidate here? The result will probably be [], and
        // the validation will not be shown in the task component
        // queryClient.invalidateQueries({ queryKey: key });
      }
    }
  );
}
